<template>
  <v-card class="ma-2">
    <v-card-title>Datos del equipo/s {{formType == "sat" ? "averiado/s" : "con incidencia"}}</v-card-title>
    <v-card-subtitle>Introduce los datos del producto/s</v-card-subtitle>
    <v-card-text>
      <v-row>
        <v-text-field
            class="ma-1"
            label="Modelo"
            v-model="model"
            outlined/>
        <v-text-field
            class="ma-1"
            label="Nº de serie"
            v-model="serialNumber"
            v-if="formType == 'sat'"
            outlined/>
        <v-text-field
            class="ma-1"
            :label="formType == 'sat' ? 'Nº de factura' : 'Nº de factura / albarán / confirmación / expedición'"
            v-model="invoice"
            outlined/>
      </v-row>
      <v-row>
        <v-textarea
            class="ma-1"
            :label="formType == 'sat' ? 'Descripción de la avería' : 'Descripción de la incidencia.'"
            :hint="formType == 'sat' ? '' : ' Detalle claramente que daños ha sufrido el producto. Tenga en cuenta que cuanta más información nos facilite más rápida será la resolución de la incidencia.'"
            v-model="description"
            outlined/>
      </v-row>
      <v-row>
        <v-btn class="ma-2 white--text" color="blue" @click="onAdd">Añadir producto</v-btn>
      </v-row>

      <v-list>
        <div v-for="device in devices" v-bind:key="device.serialNumber">
          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>Modelo {{device.model}}</v-list-item-title>
              <v-list-item-subtitle>Factura {{device.invoice}}</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn icon>
                <v-icon color="grey lighten-1" @click="onDelete(device)">mdi-delete</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </div>
        

      </v-list>
      
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "Device",
  props: ["devices", "formType"],
  data() {
    return {
      model: "",
      serialNumber: "",
      invoice: "",
      description: "",
      showCurrent: true
    }
  },
  methods: {
    onAdd() {
      this.devices.push({
        model: this.model,
        serialNumber: this.serialNumber,
        invoice: this.invoice,
        description: this.description
      });
      this.model = ""
      this.serialNumber = ""
      this.invoice = ""
      this.description = ""

    },
    onDelete(device) {
      this.devices.splice(this.devices.indexOf(device), 1);
    }
  }
}
</script>

<style scoped>

</style>